<script setup lang="ts" generic="T extends 'file' | 'data'">
import EntitySidebarField from '@/modules/Project/Entity/EntitySidebarField.vue'
import EntitySidebarFieldContainer from '@/modules/Project/Entity/EntitySidebarFieldContainer.vue'
import type {
  DeletableFileFieldEmits,
  FieldEmits,
  FieldProps,
  PreviewableFieldFileFieldEmits,
} from '@/modules/Project/Fields/field-types'
import FileField from '@/modules/Project/Fields/registry/file/FileField.vue'

defineProps<FieldProps<T>>()
const emit = defineEmits<FieldEmits<T> & DeletableFileFieldEmits & PreviewableFieldFileFieldEmits>()
</script>

<template>
  <EntitySidebarField
    :field="field"
    :property="property"
  >
    <template #field="{ labelId }">
      <EntitySidebarFieldContainer class="pl-1.5">
        <FileField
          :property="property"
          :field="field"
          :aria-labelledby="labelId"
          @focus="emit('focus', $event)"
          @blur="emit('blur', $event)"
          @file:delete="emit('file:delete', $event)"
          @file:preview="emit('file:preview', $event)"
        />
      </EntitySidebarFieldContainer>
    </template>
  </EntitySidebarField>
</template>
